/* global jQuery, horseltestAssetsUrl, horseltestRegisterUrl, horseltestFormId */

(function ($) {

    'use strict';

    var Word = {

        loader: $('#loader'),
        body: $('body'),
        starter: $('#starter'),
        startTest: $('#start-test'),
        restartTest: $('#restart-test'),
        sectionTest: $('#test'),
        sectionResult: $('#result'),
        sectionForm: $('#form'),
        sectionEnd: $('#end'),
        noWord: $('#no-word'),
        progressBar: $('#progress').find('.bar'),
        progressText: $('#progress').find('.text'),
        meter: $('#meter').find('span'),
        form: $(`#gform_${horseltestFormId}:not(.start)`),
        formWrapper: $(`#gform_wrapper_${horseltestFormId}`),

        words: ['dukar', 'bollar', 'korgar', 'ringar', 'vantar', 'lador', 'mossor', 'pennor', 'skalar', 'knappar'],
        randomSequence: [],
        snrSequence: [],
        userResponse: [],
        postResult: {},

        resultLow: {
            'result': 'sämre än normalt.',
            'message': 'Det innebär att du bör kontakta hörselvården och boka tid för hörselundersökning hos audionom. Har du frågor, kontakta gärna HRFs rådgivningstjänst Hörsellinjen. <a target="_blank" class="track-extern" data-category="extern" title="Hörsellinjen" href="http://www.horsellinjen.se">Hörsellinjen</a>',
        },

        resultNormal: {
            'result': 'normalt.',
            'message': 'Förvånad över resultatet? Om du själv tycker att du hör sämre ska du lyssna på det. Kontakta hörselvården och boka tid för hörselundersökning. Har du frågor, kontakta gärna HRFs rådgivningstjänst <a target="_blank" class="track-extern" data-category="extern" title="Hörsellinjen" href="http://www.horsellinjen.se">Hörsellinjen</a>.'
        },

        currentMethod: null,

        currentWord: 0, // index of randomSequence
        clickCache: null,
        initialSNR: 4,
        currentSNR: 0,
        myStepSize: 2,

        lowResult: -4,
        // Peter säger: "Mitt förslag är att tröskeln sätt till -4 dB istället för nuvarande -6 dB.
        // I övrigt samma som förut. lowRes:Number=-4;

        totalSteps: horseltestSteps, // Possibility to change for testing, should be 20

        maxSNR: 2,
        minSNR: -16,
        meanSNR: null,

        assetsUrl: horseltestAssetsUrl,

        init: function () {

            var loaded = 0;

            for (var key in this.words) {

                var word = this.words[key],
                    method = 'say' + Util.ucFirst(word);

                this[method] = new Howl({
                    src: [this.assetsUrl + '/sounds/' + word + '.wav', this.assetsUrl + '/sounds/' + word + '.mp3'],
                    onload: function(){
                        loaded++;
                        if (this.words.length == loaded) {

                            this.background = new Howl({
                                src: [this.assetsUrl + '/sounds/white-noise.wav', this.assetsUrl + '/sounds/white-noise.mp3'],
                                loop: true,
                                onload: function(){

                                    // Preload ready
                                    this.randomSequence = this.generateSequence(this.words);

                                    this.loader.hide();
                                    this.starter.show();

                                    this.currentSNR = this.initialSNR;
                                    //console.log('settings currentSNR to: ' + this.initialSNR);

                                    this.bindTestEvents();

                                    // debug only!
                                    // this.placeResult(0, 5.862723967249723);

                                }.bind(this)
                            });
                        }

                    }.bind(this),
                    onend: function(){
                        this.noise('fadeout');
                    }.bind(this)
                });

            }

        },

        generateSequence: function(words)
        {

            var usedWords = [],
                randomSequence = [],
                currentSelect = null,
                lastSelect = null,
                randomIndex = null,
                count = 0,
                slot = 0;

            for (var i = 0; i < this.totalSteps; i++) {

                do {

                    randomIndex = Util.random(0, 9, true);

                } while (randomIndex == lastSelect || usedWords[randomIndex] >= 3);

                count = usedWords[randomIndex] || 0;
                usedWords[randomIndex] = parseInt(count + 1);

                randomSequence[i] = words[randomIndex];
                lastSelect = randomIndex;

            }

            // // debug to check if a word occurs more then 3 times.
            // for (var key in usedWords) {
            //  console.log(key + ' : ' + usedWords[key]);
            // }

            // debug the sequence.
            //console.log('randomSequence generated:');
            for (var key in randomSequence) {
                //console.log(key + ' : ' + randomSequence[key]);
            }

            return randomSequence;

        },

        bindTestEvents: function()
        {

            // console.log(this.randomSequence);
            // console.log(this);

            this.startTest.on('click', function(e){

                e.preventDefault();

                /*if ($("input[name='gender']").val() == "") {
                    window.location = "/";
                }*/

                this.starter.fadeOut(500);

                //console.log('start the test...');

                if (this.body.hasClass('testing')) return;
                if (this.startTest.hasClass('disable')) return;

                this.body.addClass('testing');
                this.finished = false;
                // this.startTest.addClass('hidden');
                // this.noWord.css({ 'display' : 'block' });

                this.progressBar.closest('div').show();

                setTimeout( function() { this.playNextWord(); }.bind(this), 1600);


                //check if progessbar in window
                var winScrollTop = $(window).scrollTop();
                var winHeight = $(window).height();
                //var progressY = $("#progress .text").offset().top + $("#progress .text").height();
                var progressY = $("#progress").offset().top + $("#progress").height();
                var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                var chrome = /CriOS/.test(navigator.userAgent);
                
                if( winHeight + winScrollTop < progressY) {
                    var body = $("html, body");
                    var destY = progressY - winHeight;
                    
                    if (iOS && $(window).width() >= 480 && !chrome) {
                        destY += 50;
                    }
                    body.delay(1500).animate({scrollTop:destY}, '100');
                }
                

            }.bind(this));

            this.restartTest.on('click', function(e){

                e.preventDefault();

                this.sectionResult.fadeOut(200, function(){

                    //console.log('restarting test');

                    this.randomSequence = this.generateSequence(this.words);
                    this.snrSequence = [];
                    this.userResponse = [];

                    //console.log('blanking snrSequence');
                    //console.log('blanking userResponse');

                    this.currentWord = 0;
                    this.currentSNR = this.initialSNR;
                    this.clickCache = null;
                    this.finished = false;

                    //console.log('currentWord: ' + this.currentWord);
                    //console.log('currentSNR: ' + this.currentSNR);

                    Howler.unmute();

                    this.body.removeClass('testing');
                    this.body.removeClass('is-playing');
                    this.starter.show();
                    // this.noWord.hide();

                    // reset progressbar
                    // this.progressBar.closest('div').hide();
                    this.progressText.text(0 + '/' + this.randomSequence.length);
                    this.progressBar.attr('style', '');

                    this.sectionTest.fadeIn(200);


                }.bind(this));

                this.sectionEnd.fadeOut(200, function(){

                }.bind(this));

            }.bind(this));

            this.body.on('click', '.select-word', function(e){
                e.preventDefault();

                if (!this.body.hasClass('testing')) return;

                var selectedElement,
                    selectedWord;

                if (this.clickCache !== null) {
                    //console.log('we have a triggered click ... selecting word');
                    selectedElement = $('li.select-word[data-word=' + this.clickCache + ']');
                    selectedWord = this.clickCache;
                    //console.log('clearing cache...');
                    this.clickCache = null;
                } else {
                    selectedElement = $(e.currentTarget);
                    selectedWord = selectedElement.data('word');
                }

                selectedElement.addClass('tap');
                setTimeout(this.removeTap, 200);

                // handle early click
                if (this.body.hasClass('is-playing')) {
                    //console.log('early click, caching work...');
                    this.clickCache = selectedWord;
                    return;
                }

                this.body.addClass('is-playing');

                this.progressText.text((this.currentWord + 1) + '/' + this.randomSequence.length);

                var position = (this.currentWord + 1) / this.randomSequence.length * 100 + '%',
                    orientation = (this.body.hasClass('is-mobile')) ? 'height' : 'width';

                // console.log(orientation + ' : ' + position);

                this.progressBar.css(orientation, position);

                //console.log('User selected "' + selectedWord + '"');

                // Test.as userResponse
                this.collectInfo(selectedWord);

                // console.log(this.currentWord);
                // console.log(this.randomSequence.length);

                if (this.currentWord === (this.randomSequence.length - 1)) {

                    // That's all folks!
                    //console.log('Last word!');

                    // currentWord isn't advanced past the last word, so this
                    // handler can re-enter here (cached "early click" replay,
                    // double tap). Guard so the test completes exactly once
                    // and the dataLayer push / form advance don't double-fire.
                    if (this.finished) {
                        return;
                    }
                    this.finished = true;

                    // Stop all sounds.
                    Howler.mute();
                    this.body.removeClass('is-playing');

                    var result = this.calculateResult();
                    /*var result = -4.5;*/
                    this.showResults(result);

                    // Tracked in GTM as a virtual pageview, fired when the
                    // result is shown (end of the test), not on submit.
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'virtual_pageview',
                        virtualPagePath: '/result/',
                    });

                    const lowResult = (result > this.lowResult) ? "Ja" : "Nej";
                    const step = this.sectionForm.data('step');
                    this.sectionForm.attr('data-step', parseInt(step)+1);

                    const $formWrapper = $(`#gform_wrapper_${horseltestFormId}`);
                    $formWrapper.find('[data-input="result"]').val(result);
                    $formWrapper.find('[data-input="isLow"]').val(lowResult);
                    $formWrapper.find('.gform_next_button').last().click();

                } else {

                    this.checkWord(this.randomSequence[this.currentWord], selectedWord);
                    this.currentWord++;
                    this.playNextWord();

                // MyGlobal.checkWord(word);
                // MyGlobal.playSound(1, MyGlobal.sequence[MyGlobal.iteration]);
                // MyGlobal.adjustVolume();


                }


            }.bind(this));

        },

        removeTap: function()
        {

            $('.select-word').removeClass('tap');

        },

        playNextWord: function()
        {

            if (this.currentWord > 0 && typeof this.stop === 'function') {
                this.stop();
            }

            this.play(this.randomSequence[this.currentWord]);

        },

        checkWord: function(question, answer)
        {

            if (question === answer) {
                //console.log('User answered correctly! Make it harder...');

                this.currentSNR -= this.myStepSize;

                if (this.currentSNR < this.minSNR) {
                    this.currentSNR = this.minSNR;
                }

            } else {

                //console.log('User failed! Make it easier...');

                this.currentSNR += this.myStepSize;

                if (this.currentSNR > this.maxSNR) {
                    this.currentSNR = this.maxSNR;
                }

            }

            //console.log('currentSNR: ' + this.currentSNR);

        },

        calculateResult: function()
        {

            var result = 0;

            // Measure last 10 answers; calculate and return avarage SNR
            for (var i = (this.randomSequence.length - this.words.length); i < this.randomSequence.length; i++) {

                result += this.snrSequence[i];

            }

            return (result / this.words.length);

        },

        play: function(word)
        {

            var volume,
                method = 'say' + Util.ucFirst(word);

            this.body.addClass('is-playing');

            this.noise('fadein', 1.0, function(){

                volume = this.signalVolume();

                //console.log('Playing "' + word + '" @ volume ' + volume);

                this.currentMethod = this[method];
                this.currentMethod.volume(1.0);

                //console.log('initial volume:' + this.currentMethod.volume());

                this.currentMethod.play();
                this.currentMethod.volume(volume);

                //console.log('adjusted volume:' + this.currentMethod.volume());

            }.bind(this));

        },

        stop: function(word)
        {
            if (this.currentMethod == null) {
                return;
            }

            if (0 < this.currentWord) {
                this.currentMethod.stop();
            }
            this.background.stop();

        },

        noise: function(action, maxvolume, callback)
        {

            var maxvolume = maxvolume || 1.0,
                callback = callback || false;

            if ('fadein' === action) {

                this.body.addClass('playing');

                this.background.play();
                this.background.volume(0);
                this.fadeIn(this.background, 0, maxvolume, callback);
                return true;

            }

            if ('fadeout' === action) {

                this.fadeOut(this.background, null);
                return true;

            }

            return false;


        },

        signalVolume: function()
        {

            // action script
            // myTransformSignal=new SoundTransform(soundVolume*Math.pow(10,currentSNR/20));
            // currentSNR = 20 * Math.log(soundChannelSignal.soundTransform.volume/soundVolume) / Math.LN10;

            var volume = 1.0 * Math.pow(10, this.currentSNR / 20).toFixed(2);

            this.currentSNR = 20 * Math.log(volume / 1.0) / Math.LN10;

            // if (1.0 < volume) {
            //  console.log('Sorry mister, ' + volume + ' is too high.');
            //  volume = 1.0;
            // }

            //console.log('volume: ' + volume);
            //console.log('currentSNR: ' + this.currentSNR);

            return volume;

        },

        fadeIn: function(sound, volume, maxvolume, callback)
        {

            var volume = parseFloat((volume + 0.01).toFixed(2));

            if (volume >= maxvolume) {
                // console.log('Current volume: ' + volume);
                callback();
                return false;
            } else {
                sound.volume(volume);
            }

            setTimeout(function(){

                this.fadeIn(sound, volume, maxvolume, callback);

            }.bind(this), 5);

        },

        fadeOut: function(sound, volume)
        {

            var volume = (volume === null) ? sound.volume() : parseFloat((volume - 0.01).toFixed(2));

            sound.volume(volume);

            if (volume < 0) {
                this.body.removeClass('is-playing');
                if (this.clickCache !== null) {
                    //console.log('we have a cached click ... triggering...');
                    //console.log(this.clickCache);
                    var button = $('.select-word[data-word=' + this.clickCache + ']');
                    if (0 < button.length) {
                        button.trigger('click');
                    }
                }
                return false;
            }


            setTimeout(function(){

                this.fadeOut(sound, volume);

            }.bind(this), 5);

        },

        collectInfo: function(word)
        {

            this.userResponse[this.currentWord] = word;
            this.snrSequence[this.currentWord] = this.currentSNR;

            // Debug collected info
            for (var key in this.userResponse) {
                //console.log(key + ' => ' + this.userResponse[key]);
            }

            // for (var key in this.snrSequence) {
            //  console.log(key + ' => ' + this.snrSequence[key]);
            // }

        },

        showResults: function(result)
        {

            this.sectionTest.fadeOut(200, function(){

                this.sectionResult.fadeIn(200, function(){

                    //console.log('Result: ' + result);
                    //console.log('LowRes: ' + this.lowResult);

                    var info = this.resultNormal;

                    if (result > this.lowResult) {

                        info = this.resultLow;

                    }

                    this.postResult = {};
                    this.placeResult(result);
                    this.sectionForm.find('.result').text(info.result);
                    this.sectionForm.find('.result-text').html(info.message);

                }.bind(this));

                this.sectionEnd.fadeIn(200, function(){

                }.bind(this));

            }.bind(this));

        },

        placeResult: function(result)
        {

            // calcResult is also added to gravity-forms.php
            var calcResult = (result - this.lowResult) * -1,
                scaleWidth = 100,
                position = 0;
            //console.log('Calculated result: ' + calcResult);

            // Also added to PDF generetor in gravity-forms.php
            var max = 9.917600346881503,
                min = -8.007410902351257;
            
            var dMax = (max + Math.abs(min)) + 1;
             /* HACK FOR FIXING POSTION*/
            // orig:var dRes = (calcResult + Math.abs(min));
            if( calcResult > 0) {
                var dRes = (calcResult*0.7 + Math.abs(min));
            } else {
                var dRes = (calcResult + Math.abs(min));
            }

            /* HACK FOR FIXING POSTION*/
            // orig: var position = (dRes / dMax * 100),
            var position = (dRes / (dMax-3) * 100),
                marginLeft = (calcResult == max) ? '-' + this.meter.outerWidth() + 'px' : '-7px',
                marginLeft = (calcResult == min) ? '0px' : '-7px';

            //console.log( "dmax" + dMax + " --dres" + dRes);
            //console.log('Place marker at : ' + position + '%');

            // console.log('saving result for post');
            if (100 < position) {
                position = 100;
            }

            this.keepResult(max, min, this.lowResult, calcResult, (result > this.lowResult) ? true : false);

            if (position < 2) {
                position = 0;
                marginLeft = 0;
            }

            this.meter.css({ 'left': position + '%', 'margin-left': marginLeft});

        },

        keepResult: function(max, min, lowResult, calcResult, isLow)
        {

            this.postResult = {
                'max' : max,
                'min' : min,
                'lowResult' : lowResult,
                'calcResult' : calcResult,
                'isLow' : isLow
            }

        }

    };

    var UI = {

        init: function()
        {

            this.menuArea = $('#header');
            this.menuButton = $('#toggle-menu');
            this.menuWrapper = $('#main-menu');
            this.loader = $('#loader');
            this.starter = $('#starter');
            this.progress = $('#progress');
            this.testWrapper = $('#button-wrapper');

            this.bindToggleMenu();

            $(window).load(function(){

                this.handleResize();

            }.bind(this));

            $(window).on('resize', function(){

                this.handleResize();

            }.bind(this));

            $(window).on('scroll', function(){

                this.handleScroll();

            }.bind(this));

        },

        handleResize: function()
        {

            var menuHeight = this.menuArea.outerHeight(),
                buttonHeight = this.menuButton.outerHeight(),
                loaderHeight = this.loader.outerHeight(),
                testHeight = this.testWrapper.outerHeight(),
                starterHeight = this.starter.outerHeight(),

                progressBar = this.progress.find('.bar');

            this.menuButton.css({ 'top' : (menuHeight - buttonHeight) / 2, 'visibility' : 'visible' });
            this.menuWrapper.css({ 'top' : menuHeight });

            this.loader.css({ 'top' : menuHeight });
            this.loader.find('img').css({ 'margin-top' : '-=' + menuHeight });

            if( $(document).height() > $(window).height()) {
                var tmpTop = menuHeight - $(window).scrollTop();
                this.starter.css({ 'top' : tmpTop });
            } else {
                this.starter.css({ 'top' : menuHeight });
            }

           

            // weird cloning to get height inside fixed element
            var holderElem = $('<div />').css({'height': 0, 'width': '100%', 'overflow': 'hidden'}).appendTo('body'),
                starterContent = $('.start-wrapper', this.starter),
                starterContentHeight = starterContent.clone().appendTo(holderElem).outerHeight();

            starterContent.css({'top' : (starterHeight / 2) - (starterContentHeight / 2) - menuHeight });

            holderElem.remove();

            if (this.menuButton.css('display') == 'none') {
                this.menuWrapper.show();
            }

            var position = (0 < Word.currentWord) ? (Word.currentWord + 1) / Word.randomSequence.length * 100 + '%' : false;

            if (this.progress.css('width') == '40px') {

                $('body').addClass('is-mobile');
                this.progress.css('height', testHeight);

                if (position) {
                    progressBar.attr('style', '');
                    progressBar.css({ 'height' : position });
                }

            } else {

                $('body').removeClass('is-mobile');

                this.progress.attr('style', '');

                if (position) {
                    progressBar.attr('style', '');
                    progressBar.css({ 'width' : position });
                }

            }

        },

         handleScroll: function()
        {

            var menuHeight = this.menuArea.outerHeight();


             if( $(document).height() > $(window).height()) {
                var tmpTop = menuHeight - $(window).scrollTop();
                this.starter.css({ 'top' : tmpTop });
            } else {
                this.starter.css({ 'top' : menuHeight });
            }

        },

        bindToggleMenu: function()
        {

            this.menuButton.on('click', function(){

                this.menuWrapper.slideToggle(100);

            }.bind(this));

        },

        centerStart: function()
        {



        }

    };

    var Start = {

        init: function()
        {   
            const $start = $('#start');
            if($start.length) {
                $('body').addClass('js-state-start');
            }

            const $testWrapper = $('#test-wrapper:not(.force-result)');
            const $form = $('#form');
            const $resultWrapper = $('#result-form');
            const $formWrapper = $(`#gform_wrapper_${horseltestFormId}`);
            const $testAgain = $('#test-again');

            // Start by hiding test
            $testWrapper.hide();

            $(document).bind('gform_page_loaded', function(event, form_id, current_page){
                $('body').removeClass('js-state-start');

                $form.data('step', current_page);
                if(current_page == 2) {
                    $start.hide();
                    $testWrapper.show();

                    $formWrapper.addClass('moved').appendTo($resultWrapper);

                    const $firstPageForm = $(`#gform_page_${horseltestFormId}_1`);
                    const $lastPageForm = $(`#gform_page_${horseltestFormId}_3`);
                    const $fields = $firstPageForm.find('[data-input]');
                    const $dataFields = $fields.filter(function(i, elem) {
                        const $this = $(elem);
                        return $this.val() !== '';
                    }).map((i, elem) => {
                        const $this = $(elem);
                        const name = $this.data('input');
                        const value = $this.val();
                        $lastPageForm.find(`[data-input="${name}"]`).val(value);
                        $testAgain.find(`[name="${name}"]`).val(value);
                    });
                }
            });

            $('select').each( function (i, elem) {
                if ($(elem).val() == '' || $(elem).val() == null) {
                    $(elem).addClass("default");
                }
                
            });

            $('select').on("focus", function (e) {
                
                if( $(e.currentTarget).val() == null ) {
                    $(e.currentTarget).val("1960");
                    $(e.currentTarget).removeClass("default");
                }
            })

            $('select').on("change", this.onSelectChange);

            // Skip submit on start submit
            // $('form.start').submit(this.onStartFormSubmit);

        },

        onSelectChange: function(e)
        {
            //console.log("onSelectChange");

            if ( $(e.currentTarget).hasClass("error")) {
                $(e.currentTarget).removeClass("error");
            }
            if ( $(e.currentTarget).hasClass("default")) {
                $(e.currentTarget).removeClass("default");
            }

        },

        onStartFormSubmit: function(e)
        {
            //console.log("onStartFormSubmit");

            var error = false;

            $('select').each( function (i, elem) {
                if ($(elem).val() == '' || $(elem).val() == null) {
                    $(elem).addClass("error");
                    error = true;
                }
                
            });

            if (error) {
                e.preventDefault();
                $("#error-message").show();
            } 

        }
    };

    var Util = {

        random: function(min, max, round)
        {

            var round = round || false,
                number = Math.random() * (max - min) + min;

            if (round) {
                return Math.round(number);
            }

            return number;

        },

        ucFirst: function(string)
        {

            return string.charAt(0).toUpperCase() + string.slice(1);

        }

    };

    UI.init();

    if (0 < $('#test').length) {
        Word.init();
    }

    if (0 < $('#start').length) {
        Start.init();
    }

    $(document).ready(function () {
        // Tracked in GTM via dataLayer event
        function trackClick(evt) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'track_click',
                trackCategory: $(evt.currentTarget).data('category'),
                trackLabel: $(evt.currentTarget).attr('title'),
            });
        }

        $('a.track').on('click', trackClick);
        $('body').on('click', 'a.track-extern', trackClick);

        // Measurement events for GTM (GA4/Google Ads). Fires once per
        // successful AJAX submission, not on reload of the result page.
        $(document).on('gform_confirmation_loaded', function (evt, formId) {
            if (String(formId) !== String(horseltestFormId)) {
                return;
            }

            window.dataLayer = window.dataLayer || [];

            // Marker rendered only when the result mail was actually
            // sent, see gform_confirmation in src/gravity-forms.php
            if ($('.js-download-results').length) {
                window.dataLayer.push({ event: 'download_results' });
            }
        });
    });

}(jQuery));
